module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs2":["rxjs"],"commonjs":"rxjs","amd":"rxjs"}
// module id = 12
// module chunks = 0